<template>
    <div class="card h-auto card-filled">
        <div class="card__text h-100 justify-content-center px-4 py-3">
            <div class="row update-item__wrapper">
                <div class="col-12">
                    <div v-for="(updateItem, index) in updates" :key="index">
                        <a class="link" :href="updateItem.url"
                            >{{ updateItem.name }} -
                            {{ updateItem.groupShort }}</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
export default {
    props: {
        loadData: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            updates: []
        };
    },

    created() {
        this.getUpdates();
    },
    methods: {
        getUpdates() {
            if (this.loadData) {
                const url = '/api/v1/domainapi/myupdates';
                Axios({
                    method: 'get',
                    url: url
                })
                    .then(response => {
                        if (!response.data === null) {
                            return false;
                        }
                        this.updates = response.data;
                        return true;
                    })
                    .catch(() => false);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.data-field {
    @include media-breakpoint-down(sm) {
        width: 100%;
    }
}

.update-item__wrapper ul {
    padding-left: 0;
}

.update-item__wrapper li {
    background-color: $brand-white;
    padding: 10px 20px;
    margin: 0 -20px;
    list-style: none;

    &:nth-child(odd) {
        background-color: $brand-gray;
    }

    &:hover {
        /* background-color: $brand-blue;*/
        cursor: pointer;
        a {
            text-decoration: underline;
            color: $brand-green-dark-new;
        }
    }
}

.update-item__divider {
    border-bottom: dashed 1px $brand-black;
}
</style>
